import React from 'react';
import { useNavigate } from 'react-router-dom';
import StandardCardLayout from './StandardCardLayout';
import QatarBankLayout from './qatar/QatarBankLayout';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';

export default function ErrorPage({ config }) {
  const mode = config?.mode || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardEN';
  const t = getTranslation(mode);
  const navigate = useNavigate();
  const design = localStorage.getItem('session_design') || 'standard_visa_en';

  const isQatar = design.startsWith('qatar_');
  const isMc = isMastercard(design);

  // 1. Qatar Bank Design
  if (isQatar) {
    return (
      <QatarBankLayout
        design={design}
        title={t.errorTitle}
        subtitle={t.errorDesc}
        mode={mode}
      >
        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
          <button
            type="button"
            className="qb-submit-btn"
            onClick={() => navigate('/')}
          >
            {t.tryAnotherCard}
          </button>
        </div>
      </QatarBankLayout>
    );
  }

  // 2. Standard Design (from manual)
  return (
    <StandardCardLayout
      title={t.errorTitle}
      subtitle={t.errorDesc}
      mode={mode}
      scheme={isMc ? 'mastercard' : 'visa'}
    >
      <div style={{ textAlign: 'center', padding: '1rem 0' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>❌</div>
        <button
          type="button"
          className="scl-btn"
          onClick={() => navigate('/')}
        >
          {t.tryAnotherCard}
        </button>
      </div>
    </StandardCardLayout>
  );
}
